import { useMutation } from '@tanstack/react-query'

import { apiPostKakaopayWebviewRegister } from '@/payment/api'

/**
 * 카카오 간편 결제수단 등록 mutation (밀봉비닐 webview 전용).
 *
 * 등록 완료는 외부 redirect → 콜백 라우트(/sealed-vinyl/card-register-callback) 복귀 시
 * PAYMENT_METHODS refetch 로 반영되므로, 여기(redirect 직전)선 캐시 무효화하지 않는다.
 */
export const usePostKakaopayWebviewRegister = () => {
  return useMutation({ mutationFn: apiPostKakaopayWebviewRegister })
}
